// @flow

import React from 'react';
import StyledButton from './button.styled';

type Props = {
  onClick: Function,
  icon?: string, // eslint-disable-line react/require-default-props
  iconSize?: string, // eslint-disable-line react/require-default-props
};

const Button = ({ onClick, icon, iconSize }: Props) => (
  <StyledButton
    onClick={onClick}
    iconSize={iconSize || '1.25rem'}
  >
    <i className={`icon-${icon || 'info'}`} />
  </StyledButton>
);

export default Button;
